var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"53","height":"53","fill":"#870808","key":0}),React.createElement("path",{"fill":"#FFF3E4","d":"M25.2322 40.7678C26.2085 41.7441 27.7915 41.7441 28.7678 40.7678L44.6777 24.8579C45.654 23.8816 45.654 22.2986 44.6777 21.3223C43.7014 20.346 42.1184 20.346 41.1421 21.3223L27 35.4645L12.8579 21.3223C11.8816 20.346 10.2986 20.346 9.32233 21.3223C8.34602 22.2986 8.34602 23.8816 9.32233 24.8579L25.2322 40.7678ZM24.5 15L24.5 39L29.5 39L29.5 15L24.5 15Z","key":1})]);
}

ArrowBottom.defaultProps = {"width":"53","height":"53","viewBox":"0 0 53 53","fill":"none"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
